import { useState } from 'react';
import './FormsFilter.css';
import { getIntakeForms } from '../../utilities/api/allForms';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

const defaultFormsFilters = {
    "companyName": "",
    "status": "",
    "service": "",
    "createdAtStart": "",
    "createdAtEnd": "",
    "updatedAtStart": "",
    "updatedAtEnd": "",
    // "submissionDateStart": "",
    // "submissionDateEnd": "",
    // "approvalDateStart": "",
    // "approvalDateEnd": "",
}

const statusOptions = [
    'new', 
    'inProgress', 
    'submitted', 
    'cancelled', 
    'changesSubmitted', 
    'changesApproved', 
    'changesRejected', 
    'complete'
]

export default function FormsFilter({ updateForms, services, isMobile, sortHeader }) {
    const [filter, setFilter] = useState(defaultFormsFilters)
    const [loading, setLoading] = useState(false)

    const getForms = async () => {
        try {
            const allForms = await getIntakeForms()
            return allForms.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1)
        } catch (error) {
            console.log(error)
        }
    }

    const resetFilter = async () => {
        setLoading(true)
        // clear content of all input fields
        const form = document.getElementById('formsFilter');
        for (let i = 0; i < form.elements.length; i++) {
            if (form.elements[i].type === 'text' || form.elements[i].type === 'date' || form.elements[i].type === 'select-one') {
                form.elements[i].value = '';
            }
        }
        setFilter(defaultFormsFilters)
        const freshFormsData = await getForms();
        updateForms(freshFormsData)
        setLoading(false)
    }

    const filterForms = async () => {
        setLoading(true)
        const freshFormsData = await getForms();
        const cleanedFilter = Object.keys(filter).reduce((acc, key) => {
            if (filter[key]) {
                acc[key] = filter[key];
            }
            return acc;
        }, {});

        const updatedFormsList = freshFormsData.filter(form => {
            return (
                (cleanedFilter.companyName ? form.companyName.toLowerCase().includes(cleanedFilter.companyName.toLowerCase().trim()) : true) &&
                (cleanedFilter.source ? form.source === cleanedFilter.source.toLowerCase() : true) &&
                (cleanedFilter.status ? form.status === cleanedFilter.status : true) &&
                (cleanedFilter.service ? form.service === cleanedFilter.service : true) &&
                (cleanedFilter.createdAtStart ? new Date(form.createdAt) >= new Date(cleanedFilter.createdAtStart) : true) &&
                (cleanedFilter.createdAtEnd ? new Date(form.createdAt) <= new Date(cleanedFilter.createdAtEnd) : true) &&
                (cleanedFilter.updatedAtStart ? new Date(form.updatedAt) >= new Date(cleanedFilter.updatedAtStart) : true) &&
                (cleanedFilter.updatedAtEnd ? new Date(form.updatedAt) <= new Date(cleanedFilter.updatedAtEnd) : true) &&
                (cleanedFilter.submissionDateStart ? new Date(form.submissionDate) >= new Date(cleanedFilter.submissionDateStart) : true) &&
                (cleanedFilter.submissionDateEnd ? new Date(form.submissionDate) <= new Date(cleanedFilter.submissionDateEnd) : true) &&
                (cleanedFilter.approvalDateStart ? new Date(form.approvalDate) >= new Date(cleanedFilter.approvalDateStart) : true) &&
                (cleanedFilter.approvalDateEnd ? new Date(form.approvalDate) <= new Date(cleanedFilter.approvalDateEnd) : true)
            );
        });

        updateForms(updatedFormsList);
        setLoading(false)
    }

    const handleChange = (evt) => {
        const newFilterData = {
            ...filter,
            [evt.target.name]: evt.target.value
        }
        setFilter(newFilterData)
    }
  return (
    <div className='FormsFilter dropdown formsFilterDropDown'>
        <button className='formsFilterDropDownToggle' id='formsFilterDropDownToggle' title='Forms Filter' data-title='Forms Filter' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
            <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            { !isMobile && <span>Filters</span> }
        </button>
        <div className='dropdown-menu formsFilterDropDown' aria-labelledby="formsFilterDropDownToggle">
            <div className='header'>
                <div className='svgContainer'>
                    <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <span>Filters</span>
            </div>
            <form id='formsFilter'>
                <div className='form-group'>
                    <label htmlFor="companyName" className='form-label'>Client Name</label>
                    <input type="text" id="companyName" name='companyName' className='form-control' onChange={handleChange} value={filter.companyName} />
                </div>
                <div className='form-group'>
                    <label htmlFor="service" className='form-label'>Service</label>
                    <select id="service" name='service' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { services.map((service, index) => (
                            <option key={index} value={service}>{service}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="status" className='form-label'>Status</label>
                    <select id="status" name='status' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { statusOptions.map((status, index) => (
                            <option key={index} value={status}>{capitalizeFirstLetter(status)}</option>
                        ))}
                    </select>
                </div>
                <div>Creation Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="createdAtStart" className='form-label'>Start</label>
                        <input type="date" id="createdAtStart" name='createdAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="createdAtEnd" className='form-label'>End</label>
                        <input type="date" id="createdAtEnd" name='createdAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div>Last Update</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="updatedAtStart" className='form-label'>Start</label>
                        <input type="date" id="updatedAtStart" name='updatedAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="updatedAtEnd" className='form-label'>End</label>
                        <input type="date" id="updatedAtEnd" name='updatedAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                {/* <div>Submission Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="submissionDateStart" className='form-label'>Start</label>
                        <input type="date" id="submissionDateStart" name='submissionDateStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="submissionDateEnd" className='form-label'>End</label>
                        <input type="date" id="submissionDateEnd" name='submissionDateEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div> */}
                {/* <div>Approval Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="approvalDateStart" className='form-label'>Start</label>
                        <input type="date" id="approvalDateStart" name='approvalDateStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="approvalDateEnd" className='form-label'>End</label>
                        <input type="date" id="approvalDateEnd" name='approvalDateEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div> */}
            </form>
            <div className='buttonContainer'>
                <button className='btn btn-primary' type='button' onClick={filterForms} form='formsFilter' disabled={loading}>Filter</button>
                <button className='btn btn-secondary' type='reset' form='formsFilter' onClick={resetFilter} disabled={loading}>Reset</button>
            </div>
        </div>
    </div>
  )
}
